import React, { useEffect, useState } from "react";
import s from "../MyAccount/MyAccount.module.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { getUser, updateUser } from "../../redux/carSlice";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, Form, Image, Input, message, Row, Upload } from "antd";
import MySidebar from "../../components/MySidebar/MySidebar";
import { useTranslation } from "react-i18next";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
  });

const UpdateUser = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.cars.userDetails);
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const [file, setFile] = useState([
    {
      uid: "1",
      url: user?.photo,
    },
  ]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [messageApi, contextHolder] = message.useMessage();

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Вы обновили информацию о пользователе!",
    });
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type='button'
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("upload")}
      </div>
    </button>
  );

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  useEffect(() => {
    form.setFieldsValue({
      first_name: user?.first_name !== undefined ? user.first_name : "",
      last_name: user?.last_name ?? "",
      phone: user?.phone_number ?? "",
      address: user?.address ?? "",
      country: user?.country ?? "",
      city: user?.city ?? "",
      company: user?.company_name ?? "",
    });
  }, [user, form]);

  const sendForm = async (values) => {
    const data = new FormData();
    data.append("first_name", values.first_name);
    data.append("last_name", values.last_name);
    data.append("phone_number", values.phone);
    data.append("address", values.address);
    data.append("country", values.country);
    data.append("city", values.city);
    data.append("company_name", values.company);

    if (file && file.length > 0) {
      file.forEach((it) => {
        data.append("photo", it.originFileObj);
      });
    }

    const res = await dispatch(updateUser(data));

    if (res.type === "user/updateUser/fulfilled") {
      success();
      dispatch(getUser());

      // form.resetFields();
    }
  };

  return (
    <div className={s.addUser}>
      {contextHolder}
      {width > 1000 ? <div className={s.top}>top</div> : null}

      <div className={s.main}>
        {width > 1000 ? <div className={s.left}>left</div> : null}
        <div className={s.center}>
          {width > 750 ? <Header /> : <MobileHeader />}
          <div className={s.contentWrapper}>
            <div className={s.content}>
              <div className={s.sidebar}>
                <MySidebar />
              </div>

              <div className={s.announcements}>
                <div className={s.updateUserForm}>
                  {width > 1000 && (
                    <div className={s.header}>
                      <div className={s.top_photo_wrapper}>
                        <img src={user?.photo} className={s.top_photo} />
                      </div>

                      <h2 className={s.h2}>
                        <EditOutlined /> &nbsp;{t("updateProfile")}
                      </h2>
                    </div>
                  )}

                  <Form
                    form={form}
                    layout='vertical'
                    className={s.form}
                    onFinish={sendForm}
                  >
                    <Row gutter={24}>
                      <Col span={width > 600 ? 12 : 24}>
                        <Form.Item name='first_name' label={t("name")}>
                          <Input
                            placeholder={`${t("enter")} ${t(
                              "name"
                            ).toLowerCase()}`}
                            className={s.userInput}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={width > 600 ? 12 : 24}>
                        <Form.Item name='last_name' label={t("lastName")}>
                          <Input
                            placeholder={t("enterLastName")}
                            className={s.userInput}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={width > 600 ? 12 : 24}>
                        <Form.Item name='phone' label={t("phone")}>
                          <Input
                            placeholder={`${t("enter")} ${t(
                              "phone"
                            ).toLowerCase()}`}
                            className={s.userInput}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={width > 600 ? 12 : 24}>
                        <Form.Item name='address' label={t("address")}>
                          <Input
                            placeholder={`${t("enter")} ${t(
                              "address"
                            ).toLowerCase()}`}
                            className={s.userInput}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={width > 600 ? 12 : 24}>
                        <Form.Item name='country' label={t("country")}>
                          <Input
                            placeholder={t("enterCountry")}
                            className={s.userInput}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={width > 600 ? 12 : 24}>
                        <Form.Item name='city' label={t("city")}>
                          <Input
                            placeholder={`${t("enter")} ${t(
                              "city"
                            ).toLowerCase()}`}
                            className={s.userInput}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={width > 600 ? 12 : 24}>
                        <Form.Item name='company' label={t("company")}>
                          <Input
                            placeholder={t("enterCompanyName")}
                            className={s.userInput}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={width > 600 ? 12 : 24}>
                        <Form.Item
                          initialValue={file}
                          name='images'
                          label={`${t("upload")} ${t("photo").toLowerCase()}`}
                        >
                          <Upload
                            listType='picture-card'
                            fileList={file}
                            onPreview={handlePreview}
                            onChange={(e) => setFile(e.fileList)}
                            multiple={false}
                            beforeUpload={() => false}
                          >
                            {file.length >= 1 ? null : uploadButton}
                          </Upload>
                          {previewImage && (
                            <Image
                              wrapperStyle={{
                                display: "none",
                              }}
                              preview={{
                                visible: previewOpen,
                                onVisibleChange: (visible) =>
                                  setPreviewOpen(visible),
                                afterOpenChange: (visible) =>
                                  !visible && setPreviewImage(""),
                              }}
                              src={previewImage}
                            />
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row className={s.btn_row}>
                      <Button className={s.btn} htmlType='submit'>
                        <EditOutlined />
                        &nbsp;{t("update")}
                      </Button>
                    </Row>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {width > 1000 ? <div className={s.right}>right</div> : null}
      </div>

      <Footer />
    </div>
  );
};

export default UpdateUser;
